import React from "react";
import { styled } from "@mui/system";
import { AgencyBannerStyle } from "./style";
const StyledWrapper = styled("section")(({ theme }) => {
    return {
        "> img": {
            display: "block",
            width: "100%",
            objectFit: "contain",
        },
        ".banner_brand-logo": {
            width: 180,
        },
    };
});
const BannerComponent = (props) => {
    if (props.UI === "agency") {
        return (React.createElement(AgencyBannerStyle, { id: "logo-icon-header" },
            React.createElement("img", { src: props.logo.src, width: "316px", loading: "eager" })));
    }
    return (React.createElement(StyledWrapper, { id: "banner" }, [
        Object.assign({ className: "brand-logo" }, props.logo),
        Object.assign({ className: "hero-banner" }, props.banner),
    ].map((img) => (React.createElement("img", Object.assign({}, img, { className: `banner_${img.className}`, alt: img.alt, key: img.src, loading: "eager" }))))));
};
export const Banner = React.memo(BannerComponent);
